<section class="dz-flex">
	<div class="padding-10" [class.dz-hidden-lg]="selectedCardId" [class.dz-hidden]="!selectedCardId">
		<dz-select [value]="selectedCardId" (valueChange)="onExploreCardSelect($event)">
			<dz-option *ngFor="let card of exploreCardFilters" [value]="card">
				<div [dcrHTMLKey]="card + '_EXPLORE_CARD_TITLE'">{{ card | dcrKey }}</div>
			</dz-option>
		</dz-select>
	</div>
	<dz-card
		[attr.data-cy]="card"
		class="margin-10"
		[class.dz-hidden]="selectedCardId"
		[class.dz-block-lg]="selectedCardId"
		[cardOptions]="{ boxShadow: true }"
		*ngFor="let card of exploreCardFilters"
		[ngClass]="{ highlight: card === selectedCardId, 'dz-underline': card !== selectedCardId }"
		(click)="onExploreCardSelect(card)"
		clickable>
		<dz-card-title align="left" class="explore-card-title text-24-bold margin-bottom-16 margin-right-96" [dcrHTMLKey]="card + '_EXPLORE_CARD_TITLE'">
			{{ card | dcrKey }}_EXPLORE_CARD_TITLE
		</dz-card-title>
		<dz-card-subtitle align="left" class="explore-card-subtitle text-16-bold" [dcrHTMLKey]="card + '_EXPLORE_CARD_SUBTITLE'">I want to:</dz-card-subtitle>
		<div dzCardContent align="left" class="explore-card-content text-16">
			<div [dcrHTMLKey]="card + '_EXPLORE_CARD_CONTENT'">{{ card | dcrKey }}_EXPLORE_CARD_CONTENT</div>
		</div>
		<div *ngIf="!selectedCardId" class="margin-top-40">
			<dz-icon type="chevron-right" class="color-blk-orange text-14"></dz-icon>
			<span class="text-16-bold" dcrHTMLKey="EXPLORE_BUTTON_TITLE">Explore</span>
		</div>
	</dz-card>
</section>
